import type { Schemas } from '#shopware'

/** Shopware `extensions.seo_redirect` payload (apiAlias `api_seo_redirect`). */
export type SeoRedirect = NonNullable<NonNullable<Schemas['ProductDetailResponse']['extensions']>['seo_redirect']>

/** Result shape consumed by `navigateTo({ redirectCode, external })`. */
export type MappedSeoRedirect = {
    /** HTTP redirect status code (301/302). */
    redirectCode: number
    /** Redirect target path (internal, leading slash + urlQuery) or absolute URL (external). */
    redirectTarget: string
    /** Whether the redirect target is an external URL. */
    externalTarget: boolean
}

/**
 * Maps a Shopware `seo_redirect` extension to the shape `navigateTo` expects.
 * Internal targets are normalised to a leading-slash path with any `urlQuery` appended;
 * external targets are passed through unchanged.
 */
export function mapSeoRedirect(redirect: SeoRedirect): MappedSeoRedirect {
    return {
        redirectCode: redirect.redirectStatusCode,
        redirectTarget: redirect.externalTarget
            ? redirect.redirectTarget
            : '/' + redirect.redirectTarget.replace(/^\//, '') + (redirect.urlQuery ? '?' + redirect.urlQuery : ''),
        externalTarget: redirect.externalTarget,
    }
}
